module.exports = __webpack_public_path__ + "img/bet365.4c9883cd.jpg";